import '../componetns/landings/default/DefaultLanding.css'
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import LoginFrameContainer from "../componetns/landings/default/LoginFrameContainer";
import LoadingPopup from '../componetns/landings/default/LoadingPopup';
import {useTypedSelector} from "../hooks/useTypedSelector";
import {config} from "../config";
import {sendUrlParams} from "../utils/sendUrlParams";
import {AuthActionCreators} from "../store/reducers/auth/action-creators";

const UNIQ_ID_STORAGE_KEY = 'uniqId';

function generateUniqId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
}


function Login() {
    const {globalLoading} = useTypedSelector(state => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
        if (config.isNutaku) {
            return;
        }

        let uniqId = localStorage.getItem(UNIQ_ID_STORAGE_KEY);

        if (!uniqId) {
            uniqId = generateUniqId();
            localStorage.setItem(UNIQ_ID_STORAGE_KEY, uniqId);
        }

        dispatch(AuthActionCreators.setUniqId(uniqId));
        sendUrlParams(uniqId, null);
    }, [dispatch]);

    return (
        <div className='login_container'>


            {globalLoading ? (
                <LoadingPopup/>
            ) : (
                <LoginFrameContainer/>
            )
            }

        </div>
    );
}

export default Login;
